<template>
    <v-card v-redirect-if-no-permission:SALARIES_MONITORING>
        <h1 style="text-align: center;padding: 10px">SALARY REPORTS</h1>
        <salary-reports :date_prop="date" :user_id_prop="user_id" :enable_employee_choose="enable_employee_choose" :regenrate_option="regenrate_option"></salary-reports>
    </v-card>
</template>

<script>
    import SalaryReports from "@/views/HRAccounting/SalaryReports";
    export default {
        props: ['date', 'user_id', 'enable_employee_choose', 'regenrate_option'],
        name: "SalaryReportIndex",
        components: {SalaryReports}
    }
</script>

<style scoped>

</style>